import sprae from "./sprae.js"; import jessie from "subscript/jessie"; sprae.use({ compile: jessie }); export * from "./sprae.js"; export default sprae